import HeaderSection from '@/components/Header/HeaderSection.vue';
import BolideAssistant from "@/components/BolideAssistant/BolideAssistant.vue";
import edit_profile_load_methods from "./edit_profile_load_methods";
import edit_profile_save_methods from "./edit_profile_save_methods";


// profile urls
const view_user_url = process.env.VUE_APP_VIEW_USER_URL;
const user_management_url = process.env.VUE_APP_USER_MANAGEMENT_URL || process.env.VUE_APP_VIEW_USER_URL;
const update_user_url = process.env.VUE_APP_UPDATE_USER_URL;

export default {
    name: "EditProfile",

    components: {
        HeaderSection,
        BolideAssistant
    },

    data() {
        return ({
            breadcrumb: [
                { id: "home", title: "Dashboard" },
                { id: "profile", title: "Profile" },
                { id: "edit", title: "Edit Profile" }
            ],

            form: {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                session_policy: "default",
                session_timeout_minutes: null,
                location: "Gauteng, South Africa",
                bio: ""
            },
            show_assistant: false,
            is_loading: false,
            is_saving: false,
            form_error: "",
            view_user_url: view_user_url,
            user_management_url: user_management_url,
            update_user_url: update_user_url
        });
    },

    mounted() {
        this.set_breadcrumb();
        this.loadUserProfile();
    },

    computed: {
        selected_user_id() {
            return this.parse_user_id(this.$route.query.user_id);
        },

        is_managed_user_edit() {
            return Boolean(this.selected_user_id);
        },

        page_title() {
            return this.is_managed_user_edit ? "Edit User" : "Edit Profile";
        },

        page_description() {
            return this.is_managed_user_edit
                ? "Update this user's personal details and contact information."
                : "Update your personal details and keep your contact information current.";
        },

        preview_name() {
            return `${this.form.first_name || ""} ${this.form.last_name || ""}`.trim();
        },

        avatar_initials() {
            const first = this.form.first_name?.charAt(0) || "";
            const last = this.form.last_name?.charAt(0) || "";
            return (first + last).toUpperCase() || "UR";
        }
    },

    methods: {
        ...edit_profile_load_methods,
        ...edit_profile_save_methods
    }
};
